export default class Lineal {}
export default class Lineal {}
